import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

import { selectEvent } from 'services/events/selectors';
import { selectDocumentSetsArray } from 'services/documentSets/selectors';
import { selectGroups } from 'services/groups/selectors';

// Constants
import { FORM_NAME } from './constants';

const selectInitialValues = createSelector(
    [selectEvent, selectDocumentSetsArray, selectGroups],
    (eventState, documentSetsArrayState, groupsState) => {
        if (!eventState) return undefined;
        const {
            schemaId,
            id,
            entityId,
            groupId,
            startDate,
            endDate
        } = eventState;

        const group = groupId && groupsState[`${groupId}`];

        const jobs = [
            documentSetsArrayState.find(
                value => value.eventId === id && value.jobType === null
            )
        ]
            .filter(value => value)
            .map(value => ({
                jobType: value.jobType,
                assignedUsers: value.assignedUsers,
                documentSetAttributes:
                    value.documentSetAttributes &&
                    value.documentSetAttributes.reduce(
                        (accumulator, currentValue) => {
                            accumulator[currentValue.schemaAttributeId] = {
                                schemaAttributeId:
                                    currentValue.schemaAttributeId,
                                isVisible: currentValue.isVisible,
                                description:
                                    currentValue.description || undefined
                            };
                            return accumulator;
                        },
                        {}
                    )
            }));

        return {
            entityId,
            schemaId,
            // Remove groupId if group doesn't exist
            groupId: group ? groupId : undefined,
            ...(startDate ? { startDate } : {}),
            ...(endDate ? { endDate } : {}),
            jobs
        };
    }
);

const formSelector = formValueSelector(FORM_NAME);

const makeSelectFormValue = field =>
    createSelector(
        state => formSelector(state, field),
        value => value
    );

export { selectInitialValues, makeSelectFormValue };
